import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import StatusIndicator, {
  type StatusIndicatorProps,
} from '@cloudscape-design/components/status-indicator';
import { PaymentStatus, type PaymentStatus as PaymentStatusT } from '@etiquetachef/types';

/**
 * Cor/ícone do `StatusIndicator` por status de pagamento. `Record` sobre o
 * enum: status novo em `PaymentStatus` reprova o typecheck aqui.
 */
const STATUS_TYPE: Record<PaymentStatusT, StatusIndicatorProps.Type> = {
  [PaymentStatus.CONFIRMED]: 'success',
  [PaymentStatus.FAILED]: 'error',
  [PaymentStatus.PROCESSING]: 'in-progress',
  [PaymentStatus.REFUNDED]: 'info',
  [PaymentStatus.PARTIALLY_REFUNDED]: 'info',
};

type Props = { status: PaymentStatusT; label?: string };

/**
 * Badge de status de pagamento do admin (Cloudscape `StatusIndicator`).
 *
 * Origem: sem issue — commit 627b442cc, 2026-06-09 18:50 +0200 (detalhe do
 * tenant em Cloudscape; substituiu o `PaymentStatusBadge` Tailwind do
 * ui-shared, que já não existe — o admin bane `@etiquetachef/ui-shared`).
 *
 * Contrato: `label` sobrepõe o texto; sem ele, `billing.paymentStatus.<status>`
 * (i18n, os 5 locales). Só apresentação — não lê Firestore.
 *
 * Usado por: `components/PaymentTable.tsx`, `features/finance/TenantFinanceTab.tsx`,
 * `features/finance/TransactionsTable.tsx` (admin web).
 */
export function PaymentStatusBadge({ status, label }: Props): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <StatusIndicator type={STATUS_TYPE[status]}>
      {label ?? t(`billing.paymentStatus.${status}`)}
    </StatusIndicator>
  );
}
